import React from 'react';

const widths = [
  { label: '100%', value: '100' },
  { label: '83.33%', value: '83.33' },
  { label: '66.66%', value: '66.66' },
  { label: '50%', value: '50' },
  { label: '33.33%', value: '33.33' },
  { label: '16.66%', value: '16.66' },
];

class FieldWidth extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  updateValue(value) {
    this.setState(
      { value },
      () => this.props.onChange(this.state.value)
    );
  }

  render() {
    return <div className="mb-3">
      <label htmlFor="widthInPercent" className="form-label">Width</label>
      <select id="widthInPercent" name="widthInPercent"
              className="form-select"
              value={this.state.value || ''}
              onChange={e => this.updateValue(e.target.value)}>
        <option key={'null'} value={''}/>
        {widths.map(width =>
          <option key={width.value} value={width.value}>{width.label}</option>
        )}
      </select>
    </div>
  }

}

export default FieldWidth;
